module.exports = __webpack_public_path__ + "static/img/down.a450e04e.svg";